import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFMFDOrderByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFMFDOrderByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        optionalAccessoriesReq: '$..OptionalAccessoriesReq',
        additionalServicesReq: '$..AdditionalServicesReq',
        hasCurrentContract: '$..HasCurrentContract',
        currentContractExpDate: '$..CurrentContractExpDate',
        hasCompletedAssessment: '$..HasCompletedAssessment',
        completedAssessmentDate: '$..CompletedAssessmentDate',
        siprRemovableHardDrivesReq: '$..SIPRRemovableHardDrivesReq',
        isFurtherTestingReq: '$..IsFurtherTestingReq',
        isPowerSourceStandard: '$..IsPowerSourceStandard',
        powerSourceVolts: '$..PowerSourceVolts',
        powerSourceHertz: '$..PowerSourceHertz',
        powerSourceAmps: '$..PowerSourceAmps',
        powerSourcePlugType: '$..PowerSourcePlugType',
        hasSpecialAccessReq: '$..HasSpecialAccessReq',
        specialAccessReqNotes: '$..SpecialAccessReqNotes',
        isArmyCustomer: '$..IsArmyCustomer',
        hasExceptionalRequirements: '$..HasExceptionalRequirements',
        exceptionalRequirementsNotes: '$..ExceptionalRequirementsNotes',
        dateEquipmentReq: '$..DateEquipmentReq',
        itPOCId: '$..ITPOCID',
        customerSignature: '$..CustomerSignature',
        crsSignature: '$..CRSSignature',
        epcSignature: '$..EPCSignature',
        totalMonoNIPRQuantity: '$..TotalMonoNIPRQuantity',
        totalMonoNIPRPrice: '$..TotalMonoNIPRPrice',
        totalColorNIPRQuantity: '$..TotalColorNIPRQuantity',
        totalColorNIPRPrice: '$..TotalColorNIPRPrice',
        totalMonoSIPRQuantity: '$..TotalMonoSIPRQuantity',
        totalMonoSIPRPrice: '$..TotalMonoSIPRPrice',
        totalColorSIPRQuantity: '$..TotalColorSIPRQuantity',
        totalColorSIPRPrice: '$..TotalColorSIPRPrice',
        totalMonoQuantity: '$..TotalMonoQuantity',
        totalMonoPrice: '$..TotalMonoPrice',
        totalColorQuantity: '$..TotalColorQuantity',
        totalColorPrice: '$..TotalColorPrice',
        totalQuantity: '$..TotalQuantity',
        totalPrice: '$..TotalPrice',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
